import React from "react";
import { Layer, Box, Text } from "grommet";
import {
  StatusGood,
  StatusInfo,
  StatusWarning,
  StatusCritical,
} from "grommet-icons";
import parse from "html-react-parser";

export const TYPE_SUCCESS = "status-ok";
export const TYPE_INFO = "blue-1";
export const TYPE_WARNING = "status-warning";
export const TYPE_ERROR = "status-critical";

class Toast extends React.Component {
  constructor() {
    super();
    this.state = {
      open: false,
      message: "",
      type: TYPE_INFO,
      modalOpen: false,
      modalMessage: "",
      modalType: TYPE_INFO,
    };
    window.toast = this;
  }

  present(message, type, delay = 3000) {
    this.setState({ ...this.state, open: true, message: message || "", type });
    setTimeout(() => {
      this.setState({ ...this.state, open: false });
    }, delay);
  }

  presentModal(message, type = TYPE_INFO) {
    this.setState({
      ...this.state,
      modalOpen: true,
      modalMessage: message || "",
      modalType: type,
    });
  }

  closeModal() {
    this.setState({ ...this.state, modalOpen: false });
  }

  render() {
    return (
      <>
        {this.state.open && (
          <Layer
            position={this.state.type === TYPE_INFO ? "top" : "bottom"}
            modal={false}
            margin={{ vertical: "medium", horizontal: "small" }}
            responsive={false}
            plain
          >
            <Box
              align="center"
              direction="row"
              gap="small"
              justify="between"
              round="medium"
              elevation="medium"
              pad={{ vertical: "xsmall", horizontal: "small" }}
              background={this.state.type}
            >
              <Box align="center" direction="row" gap="xsmall">
                {this.state.type === TYPE_SUCCESS && (
                  <StatusGood color="white" />
                )}
                {this.state.type === TYPE_INFO && <StatusInfo color="white" />}
                {this.state.type === TYPE_WARNING && (
                  <StatusWarning color="white" />
                )}
                {this.state.type === TYPE_ERROR && (
                  <StatusCritical color="white" />
                )}
                <Text color="white">{parse(this.state.message)}</Text>
              </Box>
            </Box>
          </Layer>
        )}
        {this.state.modalOpen && (
          <Layer
            modal={true}
            onClickOutside={() => {}} // Prevent closing on click outside
            onEsc={() => {}} // Prevent closing on Esc key
            full="vertical"
            margin={{ horizontal: "small", vertical: "small" }}
          >
            <Box
              fill
              align="center"
              justify="center"
              pad="large"
              background={this.state.modalType}
              round="small"
            >
              <Box
                align="center"
                direction="row"
                gap="small"
                margin={{ bottom: "medium" }}
              >
                {this.state.modalType === TYPE_SUCCESS && (
                  <StatusGood color="white" size="large" />
                )}
                {this.state.modalType === TYPE_INFO && (
                  <StatusInfo color="white" size="large" />
                )}
                {this.state.modalType === TYPE_WARNING && (
                  <StatusWarning color="white" size="large" />
                )}
                {this.state.modalType === TYPE_ERROR && (
                  <StatusCritical color="white" size="large" />
                )}
              </Box>
              <Box align="center" pad="medium">
                <Text color="white" size="large" textAlign="center">
                  {parse(this.state.modalMessage)}
                </Text>
              </Box>
            </Box>
          </Layer>
        )}
      </>
    );
  }
}

export default Toast;
export function presentToastInfo(message) {
  window.toast.present(message, TYPE_INFO);
}
export function presentToastWarning(message) {
  window.toast.present(message, TYPE_WARNING);
}
export function presentToastError(message) {
  window.toast.present(message, TYPE_ERROR);
}
export function presentToastSuccess(message) {
  window.toast.present(message, TYPE_SUCCESS);
}
export function presentToastLink(message, link, type = TYPE_INFO) {
  message = message.replace(
    /(.*)\[(.*)\](.*)/,
    '$1<a href="' + link + '">$2</a>$3',
  );
  window.toast.present(message, type, 30000);
}
export function presentModalLink(message, link, type = TYPE_ERROR) {
  message = message.replace(
    /(.*)\[(.*)\](.*)/,
    '$1<a href="' + link + '">$2</a>$3',
  );
  window.toast.presentModal(message, type);
}
export function getErrorMessage(error) {
  const responseMessage =
    error && error.response && error.response.data
      ? error.response.data.message
      : undefined;
  const candidates = [responseMessage, error && error.message, error];

  for (const candidate of candidates) {
    if (typeof candidate === "string" && candidate.trim()) {
      return candidate;
    }
    if (
      candidate &&
      typeof candidate.message === "string" &&
      candidate.message.trim()
    ) {
      return candidate.message;
    }
  }

  return "An unexpected error occurred.";
}
export function presentToastErrorContent(error) {
  presentToastError(getErrorMessage(error));
}
